import apiFn from 'common/services/api-service';

const api = () => apiFn('/api/cms/v1/interfaces/feature_flag_ui');

export const getFeatureFlagsForEvent = async shortcode =>
  api()
    .get('/events_feature_flags', { params: { shortcode } })
    .then(response => response.data.data);

export const updateFeatureFlag = async (shortcode, flagId, enabled) =>
  api()
    .post('/events_feature_flags', { id: flagId, shortcode, enabled })
    .then(response => response.data.data);
